export default "__VITE_ASSET__BQzfaeO0__"